import { createApi } from "@reduxjs/toolkit/query/react";
import { defaultBaseQuery } from "../../utils/API/fetchBaseQuery";
import { transformRequest } from "../../utils/API/requestMiddleware";
import { transformErrorResponse, transformSuccessResponse } from "../../utils/API/responseMiddleware";

const wordDocumentAPI = createApi({
    baseQuery: defaultBaseQuery,
    reducerPath: 'wordDocumentAPI',
    endpoints: (builder) => ({

        addWordDocument: builder.mutation({
            query: (data) => ({
                url: `/WordDocument/AddWordDocument`,
                method: `POST`,
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        updateWordDocument: builder.mutation({
            query: (data) => ({
                url: `/WordDocument/UpdateWordDocument`,
                method: `POST`,
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getWordDocumentsList: builder.mutation({
            query: (data) => ({
                url: `/WordDocument/GetWordDocuments`,
                method: `POST`,
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        deleteWordDocuments: builder.mutation({
            query: (wordDocID) => ({
                url: `/WordDocument/DeleteWordDocuments?WordDocID=${wordDocID}`,
                method: `DELETE`,
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        downloadDocument: builder.mutation({
            query: (fileName) => ({
                url: `WordDocument/DownloadDocument?fileName=${fileName}`,
                method: `GET`,
                responseHandler: (response)=> response.blob(),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getAllWordDocumentsList: builder.query({
            query: () => ({
                url: `/WordDocument/GetAllWordDocuments`,
                method: `GET`,
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        updateWordDocumentStatusToggle: builder.mutation({
            query: (data) => ({
                url: `/WordDocument/UpdateWordDocumentStatusToggle`,
                method: `POST`,
                body: transformRequest(data)
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        downloadCsvFile: builder.mutation({
            query: (req) => ({
                url: `WordDocument/DownloadCsvFile?reportTemplateID=${req?.reportTemplateID}&outFileName=${req?.outFileName}`,
                method: `GET`,
                responseHandler: (response)=> response.blob(),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getWordDocumentById: builder.query({
            query: (id) => ({
                url: `WordDocument/GetWordDocumentById?WordDocID=${id}`,
                method: `GET`,
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
       })
});

export const { 
    useAddWordDocumentMutation, 
    useUpdateWordDocumentMutation, 
    useGetWordDocumentsListMutation, 
    useDeleteWordDocumentsMutation,
    useDownloadDocumentMutation ,
    useLazyGetAllWordDocumentsListQuery,
    useUpdateWordDocumentStatusToggleMutation,
    useDownloadCsvFileMutation,
    useLazyGetWordDocumentByIdQuery
} = wordDocumentAPI;

export default wordDocumentAPI;